import React, { Component } from "react";
import {t} from "../../../../helpers/translator";
import {Link} from "react-router";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import Helpers from "../../../../helpers/helperFunctions";

class Favorit extends Component {
    render () {
        let {gameType, favoritesGamesLength} = this.props;
        return (<Link className="favorite-item" key="favorites" to={`/${gameType}/Favorites`}
                      activeClassName="active">
                        <span className="sport-icon-m favorites">
                            <i className="games-count-view-m">{favoritesGamesLength}</i>
                        </span>
            <p>{t("Favorites")}</p>
        </Link>);
    }
}

Favorit.propTypes = {
    gameType: PropTypes.string,
    favoritesGamesLength: PropTypes.number
};

const mapStateTopProps = (_) => {
    return createSelector(
        [
            state => Helpers.objectToArray(state.favorites.game).length
        ],
        (favoritesGamesLength) => {
            return {
                favoritesGamesLength
            };
        });
};

export default connect(mapStateTopProps)(Favorit);